import { connect } from 'react-redux'
import { arrayOf, bool, func, shape, string } from 'prop-types'
import React from 'react'
import { determineSelectedView, getSortOptions } from '../../selectors'
import { sortControlWasClicked } from '../../actions/sort'
import Button from './Button'
import Option from './Option'

class SortSelect extends React.PureComponent {
  handleClick = () => {
    window.scrollTo(0, 0)
    this.handleControlClick()
  }
  handleControlClick = () => {
    this.props.sortControlWasClicked(this.props.esKey)
  }
  render() {
    if (this.props.selectedView === 'map') {
      return null
    }
    return (
      <div className="sort-select">
        <Button
          handleControlClick={this.handleControlClick}
          isOpen={this.props.isOpen}
          options={this.props.options}
        />
        {this.props.isOpen &&
          <div className="panel">
            <ul>
              {this.props.options.map(option => (
                <Option
                  href={option.href}
                  isChecked={option.isChecked}
                  key={option.value}
                  name={option.name}
                  onClick={this.handleClick}
                  value={option.value}
                />
              ))}
            </ul>
          </div>
        }
      </div>
    )
  }
}
SortSelect.propTypes = {
  isOpen: bool.isRequired,
  options: arrayOf(shape({
    href: string.isRequired,
    isChecked: bool.isRequired,
    name: string.isRequired,
    value: string.isRequired,
  })).isRequired,
  selectedView: string.isRequired,
  sortControlWasClicked: func.isRequired,
}

const mapStateToProps = state => ({
  isOpen: state.sort.isOpen,
  options: getSortOptions(state),
  selectedView: determineSelectedView(state),
})

export default connect(mapStateToProps, {
  sortControlWasClicked,
})(SortSelect)
